var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 41"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11",
    d: "M56.5 28.5C56.5 43.964 43.964 56.5 28.5 56.5C13.036 56.5 0.5 43.964 0.5 28.5C0.5 13.036 13.036 0.5 28.5 0.5C43.964 0.5 56.5 13.036 56.5 28.5Z",
    fill: "#ECF1F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tv_signin"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2778_27123",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 16.5,
    y: 16.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2778_27123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tv_signin_2",
    d: "M24.8461 31.1538H32.1538V30.7961C32.1538 30.1295 31.824 29.6057 31.1644 29.225C30.5048 28.8442 29.6166 28.6538 28.5 28.6538C27.3833 28.6538 26.4952 28.8442 25.8356 29.225C25.176 29.6057 24.8461 30.1295 24.8461 30.7961V31.1538ZM28.5 27.3461C28.9859 27.3461 29.399 27.1759 29.7394 26.8356C30.0798 26.4952 30.25 26.082 30.25 25.5961C30.25 25.1102 30.0798 24.6971 29.7394 24.3567C29.399 24.0163 28.9859 23.8462 28.5 23.8462C28.0141 23.8462 27.6009 24.0163 27.2606 24.3567C26.9202 24.6971 26.75 25.1102 26.75 25.5961C26.75 26.082 26.9202 26.4952 27.2606 26.8356C27.6009 27.1759 28.0141 27.3461 28.5 27.3461ZM25 37V35H20.8077C20.3026 35 19.875 34.825 19.525 34.475C19.175 34.125 19 33.6974 19 33.1923V21.8077C19 21.3026 19.175 20.875 19.525 20.525C19.875 20.175 20.3026 20 20.8077 20H36.1923C36.6974 20 37.125 20.175 37.475 20.525C37.825 20.875 38 21.3026 38 21.8077V33.1923C38 33.6974 37.825 34.125 37.475 34.475C37.125 34.825 36.6974 35 36.1923 35H32V37H25ZM20.8077 33.5H36.1923C36.2692 33.5 36.3397 33.4679 36.4038 33.4038C36.4679 33.3397 36.5 33.2692 36.5 33.1923V21.8077C36.5 21.7308 36.4679 21.6602 36.4038 21.5961C36.3397 21.532 36.2692 21.5 36.1923 21.5H20.8077C20.7308 21.5 20.6602 21.532 20.5961 21.5961C20.532 21.6602 20.5 21.7308 20.5 21.8077V33.1923C20.5 33.2692 20.532 33.3397 20.5961 33.4038C20.6602 33.4679 20.7308 33.5 20.8077 33.5Z",
    fill: "#15202A"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41);
export default __webpack_public_path__ + "static/media/Group 41.68285a07f584fbbd8a79f8b4f6e878b0.svg";
export { ForwardRef as ReactComponent };